import { render, staticRenderFns } from "./Lgx315088047525855232.vue?vue&type=template&id=35ef3af1&scoped=true&"
import script from "./Lgx315088047525855232.vue?vue&type=script&lang=js&"
export * from "./Lgx315088047525855232.vue?vue&type=script&lang=js&"
import style0 from "./Lgx315088047525855232.vue?vue&type=style&index=0&id=35ef3af1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef3af1",
  null
  
)

export default component.exports